<template>
  <div class="main">
    <div class="nav">
      <van-nav-bar
        title="就诊人列表"
        right-text="+"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
      />
    </div>
    <div class="empty" v-if="emptyflag">
      <van-empty image="https://account.kmmds.top/datainfo_pic/error.png" description="暂无就诊卡信息" />
       <div class="emptyBtn">
        <van-button
        color="#5B8DF6"
        plain
        size="large"
        class="emptyBtn_text"
        round
        @click="onClickRight"
        >立即绑卡</van-button
      >
     </div>
    </div>
    <div class="cell">
      <div
        class="item"
        size="large"
        v-for="(item, index) in cardList"
        :key="index"
      >
        <div class="cell_item">
          <div class="title">{{ item.PatientName }}</div>
          <div class="value">{{ item.PatientID }}</div>
        </div>
        <div class="cell_item">
          <div class="value">tel: {{ item.Mobile }}</div>
          <!-- class="btn_mini_style" -->
          <div>
            <van-button
              color="#5B8DF6"
              size="small"
              class="btn_mini_style"
              round
              @click="Dialog(item.PatientName, item.PatientID, item)"
              >选择</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="submit" v-if="showbtn">
      <button class="bottom_button" type="info" @click="submit1" size="nomal"  >添加就诊卡</button>
    </div> -->
  </div>
</template>

<script>
import Nav from "@/components/nav.vue";
export default {
  data() {
    return {
      cardList: "",
      path: "",
      source: 1,
      showbtn: false,
      emptyflag: false,
      healthCardflag:null
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.source = this.$route.query.source;
    console.log(1111)
    this.getclientId();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.path = from.path;
    });
  },
  methods: {
     async gethealthCardflag() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/healthcardcontroller/gethealthCardflag";
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
            this.healthCardflag = data.data;
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //获取
    async getclientId() {
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/medicalcard/getclientcardlist";
        let data = null;
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
                this.gethealthCardflag()

            if (this.path == "/details_ymzyy") {
              this.cardList = data.data;
              if (data.data.length > 4) {
                this.showbtn = false;
              } else {
                this.showbtn = true;
              }
              if (data.data.length === 0) {
                this.emptyflag = true;
              } else if (data.data.length > 0) {
                this.emptyflag = false;
                console.log();
              }
              // console.log(data.data);

              this.$hideLoad();
              return
            }
            // 添加就诊卡按钮显示
            this.cardList = data.data;
            console.log(data);
            if (data.data.length > 4) {
              this.showbtn = false;
            } else {
              this.showbtn = true;
            }
            if (data.data.length === 0) {
              this.emptyflag = true;
            } else if (data.data.length > 0) {
              this.emptyflag = false;
              console.log();
            }
            // console.log(data.data);

            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    onClickLeft() {
      this.$router.push("/index");
    },
    //跳转新建绑卡页
    onClickRight() {
      // console.log(1234);
       this.$router.push({
        path: this.healthCardflag?"/HealthcardListD":"/patient_card_bind_D",
        query: {
          ispath: "1",
        },
      });
    },
    //确认事件
    Dialog(name, clientId, item) {
      let a_name = name;
      console.log(123 + name);
      this.$dialog
        .confirm({
          message: "确认选择用户:" + name,
        })
        .then(() => {
            this.$router.push({
            path: this.path,
            query: {
              name,
              clientId,
              item,
            },
          });
          
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style lang="scss">
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar__title {
  color: white;
}
.van-nav-bar__text {
  color: white;
}
.van-nav-bar {
  background-color: #5b8df6;
}
.nav {
  letter-spacing: 5px;
}
.van-nav-bar__left,
.van-nav-bar__right {
  font-size: 25px;
}
.main {
  width: 100%;
  height: 100vh;
  .cell {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    .item {
      display: flex;
      flex-direction: column;
      padding-top: 16px;
      padding-bottom: 16px;
      &::after {
        border-bottom: 0;
      }
      margin-bottom: 15px;
      background-color: #f7f8fa;
      box-shadow: 0 8px 12px #ebedf0;
      border-radius: 8px;
      .cell_item {
        width: 93%;
        line-height: 40px;
        margin-left: 10px;
        margin-right: 10px;
        display: flex;
        justify-content: space-between;
        .title {
          font-size: 18px;
          color: #323233;
        }
        .value {
          font-size: 16px;
          color: #555;
        }
        .label {
          font-size: 15px;
          color: #999;
        }
      }
    }
  }
}
.submit {
  margin: 0px 0px;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 70px;
  display: flex;
  justify-items: center;
  align-items: center;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .bottom_button {
    width: 90%;
    margin: 0px auto;
    border: 0px;
    background-color: #5b8df6;
    border-radius: 999px;
    height: 50px;
    color: white;
    letter-spacing: 10px;
    font-size: 14px;
  }
}
.submit .bottom_button {
  border-radius: 10px;
}
.emptyBtn{
      width: 80%;
      margin: 0px auto;
      margin-top: 25vh;

      .emptyBtn_text{
        letter-spacing:5px;
      }
    }
</style>